import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-backup",
  "use": "icon-backup-usage",
  "viewBox": "0 0 240 240",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 240 240\" id=\"icon-backup\"><defs><style>#icon-backup .cls-1{stroke:#231815;stroke-miterlimit:10;}</style></defs><path class=\"cls-1\" d=\"M48.55,115.23l40.94,7.07v14l34.91,5.59,1.78,26.94,29.64,6,.38,27.29h44.19V60.88L161.7,45.15,89.49,57.38V70L48.55,78.11v13H25v10H48.55Zm87.11,45.3-1.13-17.05,20.91,3.34.24,17.8ZM99.49,65.83l61.07-10.35,29.83,12.13V192.14H166.06l-.74-53.87L99.49,127.74ZM58.55,86.33l30.94-6.1v31.92l-30.94-5.34Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol